import API from "../store/api";
import { authLogin, authLogout } from '../store/actions/authActions';
import { setMessage } from '../store/actions/dialogActions';

export const login = (emailInput, passwordInput) => {
  return async dispatch => {
    API.post("/portal/login")
      .send({ email: emailInput, password: passwordInput })
      .then((response) => {
        dispatch(authLogin(response.body));
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          } 
        }
        dispatch(setMessage({
          title: 'Login Failed',
          message: message,
          type: 'ERR',
        }))
        dispatch(authLogout);
      })
  }
}